import { Component, type ErrorInfo, type ReactNode } from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  public state: State = { hasError: false };

  public static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  public componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error("FunnelBoard gagal dipaparkan", error, info);
  }

  public render(): ReactNode {
    if (!this.state.hasError) return this.props.children;

    return (
      <main className="fatal-error" role="alert">
        <div className="fatal-error__card">
          <span className="fatal-error__icon"><AlertTriangle size={28} /></span>
          <p className="eyebrow">RALAT APLIKASI</p>
          <h1>Kanvas tidak dapat dimuatkan.</h1>
          <p>Kerja anda kekal disimpan dalam pelayar. Muat semula untuk mencuba sekali lagi.</p>
          <button className="button button--primary" onClick={() => window.location.reload()} type="button">
            <RefreshCw size={16} /> Muat semula
          </button>
        </div>
      </main>
    );
  }
}

